import Markdown from "@ronradtke/react-native-markdown-display";
import type { TextProps as BaseTextProps } from "tamagui";

import { TextAttributesMapper } from "@/ui/core/Text";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

interface MarkdownProps extends BaseViewProps {
  content: string;
  role?: BaseTextProps["role"];
}

const MarkdownParser = ({
  accessibilityLabel,
  content,
  role,
  testID,
}: MarkdownProps) => {
  const textAttributes = TextAttributesMapper["body"];
  const { fontFamily, fontSize, letterSpacing, lineHeight } = textAttributes;
  return (
    <Box aria-label={accessibilityLabel} role={role} testID={testID}>
      <Markdown
        style={{
          text: {
            color: ColorToken.NeutralPrimary,
            fontFamily,
            fontSize,
            letterSpacing: fontSize * letterSpacing,
            lineHeight: lineHeight * fontSize,
          },
        }}
      >
        {content}
      </Markdown>
    </Box>
  );
};
export type { MarkdownProps };
export default MarkdownParser;
